// extracted by mini-css-extract-plugin
export default {"mapHistory":"LocationHistory_mapHistory__Lb72a","popup":"LocationHistory_popup__YQhQM"};